/** @format */

import createMiddlewareSaga from "redux-saga";

export const middlwareSaga = createMiddlewareSaga();
